<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0 pl-0 pr-0">
      <v-row no-gutters class="d-flex justify-content-center">
        <v-icon class="page-icon pt-1 mr-2" color="#2e384d" size=60>mdi-camera</v-icon>
        <v-icon class="page-icon pb-1 ml-2" color="#2e384d" size=64>mdi-car</v-icon>
      </v-row>
      <CameraDesktop ref="cameraDesktop" :documentType="documentType" :dataId="carId" />
      <v-progress-circular
        v-if="isUploading"
        class="mt-2"
        indeterminate
        color="#033e8c"
      ></v-progress-circular>
      <v-row no-gutters class="px-3 mt-4">
        <v-btn
          class="submit-btn"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          @click="complete"
          >
          {{ title }}
        </v-btn>
        </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import CameraDesktop from "@/components/camera/CameraDesktop.vue"
import { DOCUMENT_TYPE_CAR_PICTURE } from "@/constants"

export default {
  name: "TakeCarPhotoPage",
  props: {},
  components: {
    AppBar,
    CameraDesktop
  },
  data() {
    return {
      title: '',
      valid: false,
      carId: -1,
      documentType: DOCUMENT_TYPE_CAR_PICTURE,
      isUploading: false,
    }
  },
  methods: {
    async uploadPictures() {
      await this.$refs.cameraDesktop.upload()
    },
    complete() {
      this.isUploading = true

      this.uploadPictures()

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
        .finally(() => {
          this.isUploading = false
        })
      } else {
        this.isUploading = false
      }
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.carId = parseInt(response.data.data.car_id.value)
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
  }
}
</script>

<style scoped>
</style>